var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._b({staticClass:"GImage",attrs:{"src":_vm._f("isWebp")(_vm.src),"alt":""}},'img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }